import React from 'react';
import { useApprovals } from './ApprovalProvider';

// What the chip says for each kind of request (finishes "Esperando aprobación: ...").
const SHORT = {
  'invoices.void': 'anular', 'invoices.credit-note': 'nota de crédito', 'invoices.debit-note': 'nota de débito',
  'clients.delete': 'eliminar', 'products.delete': 'eliminar', 'quotes.delete': 'eliminar', 'conduces.delete': 'eliminar',
  'client-prices.delete': 'eliminar', 'expenses.delete': 'eliminar', 'expenses.update': 'modificar',
};

// A small "waiting for an admin" mark next to a record that someone asked to change or delete. (Sending an invoice to DGII and
// verifying a cobro have their own indicators, so they don't show here.)
const ApprovalChip = ({ entityId, className = '' }) => {
  const { waitingOn } = useApprovals();
  const waiting = waitingOn(entityId).filter(r => SHORT[r.action]);
  if (!waiting.length) return null;
  const first = waiting[0];
  return (
    <span
      className={`badge ${className}`}
      title={`${first.requestedBy} pidió ${SHORT[first.action]}; un administrador debe aprobarlo`}
      style={{ background: 'rgba(245,183,0,0.15)', color: 'var(--mm-yellow)', border: '1px solid rgba(245,183,0,0.4)', fontWeight: 500 }}
    >
      <i className="bi bi-hourglass-split me-1" />Esperando aprobación: {SHORT[first.action]}{waiting.length > 1 ? ` (+${waiting.length - 1})` : ''}
    </span>
  );
};

export default ApprovalChip;
